import Home from "../components/Home";


const HomeView = () => {

    return (
        <div className="home">
            <Home/>
        </div>
    );
};

export default HomeView;